const Pages = {
  Projects: 'projects',
  Studio: 'studio'
}

export default Pages